import React, { createContext, useEffect } from 'react';
import Cookie from 'js-cookie';
import useLocalStorage from '../../util/hooks/useLocalStorage';

export interface IFeatureFlagContext {
  enableReferrals?: boolean;
  setEnableReferrals: (enabled?: boolean) => void;
  healCorp?: boolean;
  setHealCorp: (enabled?: boolean) => void;
  enableChangeServiceType?: boolean;
  setEnableChangeServiceType: (enabled?: boolean) => void;
}

export const FeatureFlagContext = createContext<IFeatureFlagContext>(null!);

export function FeatureFlagProvider({ children }: React.PropsWithChildren<{}>) {
  const [enableReferrals, setEnableReferrals] = useLocalStorage('enableReferrals', false);
  const [healCorp, setHealCorp] = useLocalStorage('healCorp', false);
  const [enableChangeServiceType, setEnableChangeServiceType] = useLocalStorage('enableChangeServiceType', false);

  // Migrate old cookie values to localStorage
  useEffect(() => {
    if (Cookie.get('enable_referrals')) {
      setEnableReferrals(true);
      Cookie.remove('enable_referrals');
    }

    if (Cookie.get('heal_corp')) {
      setHealCorp(true);
      Cookie.remove('heal_corp');
    }
  }, [setEnableReferrals, setHealCorp]);

  return (
    <FeatureFlagContext.Provider value={{ enableReferrals, setEnableReferrals, healCorp, setHealCorp, enableChangeServiceType, setEnableChangeServiceType }}>
      {children}
    </FeatureFlagContext.Provider>
  );
}
